import React, { Fragment } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 20px;
`

const CloseWrapper = styled.div`
  position: fixed;
  right: 30px;
  top: 0px;
  height: 50px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 20px;
`

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 0px 20px;
  height: 50px;
`

export const MobileModal = ({children, backgroundColor='var(--white)', visible, close, logo}) => {

  if (!visible){
    return null
  }

  return (
    <Wrapper style={{backgroundColor: backgroundColor}} onClick={close}>
      <LogoWrapper>{logo}</LogoWrapper>
      <CloseWrapper onClick={close}>
        <FontAwesomeIcon icon={faTimes} color={backgroundColor === 'var(--white)' ? 'var(--black)' : 'var(--white)'} />
      </CloseWrapper>
      <InnerWrapper>
        {children}
      </InnerWrapper>
    </Wrapper>
  );
};
